// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntitlementType } from './EntitlementType';
import {
  EntitlementTypeFromJSON,
  EntitlementTypeFromJSONTyped,
  EntitlementTypeToJSON,
  EntitlementTypeToJSONTyped,
} from './EntitlementType';
import type { EntitlementStatus } from './EntitlementStatus';
import {
  EntitlementStatusFromJSON,
  EntitlementStatusFromJSONTyped,
  EntitlementStatusToJSON,
  EntitlementStatusToJSONTyped,
} from './EntitlementStatus';

/**
 *
 * @export
 * @interface EntitlementResponse
 */
export interface EntitlementResponse {
  /**
   * id of the entitlement
   * @type {string}
   * @memberof EntitlementResponse
   */
  id: string;
  /**
   * amount of ACUs
   * @type {number}
   * @memberof EntitlementResponse
   */
  amount: number;
  /**
   * cost basis
   * @type {string}
   * @memberof EntitlementResponse
   */
  costBasis: string;
  /**
   *
   * @type {EntitlementStatus}
   * @memberof EntitlementResponse
   */
  status: EntitlementStatus;
  /**
   *
   * @type {EntitlementType}
   * @memberof EntitlementResponse
   */
  type: EntitlementType;
  /**
   * start timestamp, RFC3339
   * @type {Date}
   * @memberof EntitlementResponse
   */
  start: Date;
  /**
   * end timestamp, RFC3339
   * @type {Date}
   * @memberof EntitlementResponse
   */
  end: Date;
  /**
   * timestamp the entitlement was claimed, RFC3339 (absent if not yet claimed)
   * @type {Date}
   * @memberof EntitlementResponse
   */
  claimedAt?: Date;
  /**
   * ORB Credit Block ID
   * @type {string}
   * @memberof EntitlementResponse
   */
  orbCreditBlockID?: string;
  /**
   * Salesforce subscription ID
   * @type {string}
   * @memberof EntitlementResponse
   */
  salesforceSubID?: string;
  /**
   * ORB Credit Block ID for the rollover
   * @type {string}
   * @memberof EntitlementResponse
   */
  rollOverCreditBlockID?: string;
  /**
   * percentage of unused ACUs that roll over to the next period
   * @type {number}
   * @memberof EntitlementResponse
   */
  rolloverPercentage?: number;
  /**
   * provisioning ID
   * @type {string}
   * @memberof EntitlementResponse
   */
  provisioningID?: string;
}

/**
 * Check if a given object implements the EntitlementResponse interface.
 */
export function instanceOfEntitlementResponse(
  value: object,
): value is EntitlementResponse {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('amount' in value) || value['amount'] === undefined) return false;
  if (!('costBasis' in value) || value['costBasis'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('start' in value) || value['start'] === undefined) return false;
  if (!('end' in value) || value['end'] === undefined) return false;
  return true;
}

export function EntitlementResponseFromJSON(json: any): EntitlementResponse {
  return EntitlementResponseFromJSONTyped(json, false);
}

export function EntitlementResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EntitlementResponse {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    amount: json['amount'],
    costBasis: json['costBasis'],
    status: EntitlementStatusFromJSON(json['status']),
    type: EntitlementTypeFromJSON(json['type']),
    start: new Date(json['start']),
    end: new Date(json['end']),
    claimedAt:
      json['claimedAt'] == null ? undefined : new Date(json['claimedAt']),
    orbCreditBlockID:
      json['orbCreditBlockID'] == null ? undefined : json['orbCreditBlockID'],
    salesforceSubID:
      json['salesforceSubID'] == null ? undefined : json['salesforceSubID'],
    rollOverCreditBlockID:
      json['rollOverCreditBlockID'] == null
        ? undefined
        : json['rollOverCreditBlockID'],
    rolloverPercentage:
      json['rolloverPercentage'] == null
        ? undefined
        : json['rolloverPercentage'],
    provisioningID:
      json['provisioningID'] == null ? undefined : json['provisioningID'],
  };
}

export function EntitlementResponseToJSON(json: any): EntitlementResponse {
  return EntitlementResponseToJSONTyped(json, false);
}

export function EntitlementResponseToJSONTyped(
  value?: EntitlementResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    amount: value['amount'],
    costBasis: value['costBasis'],
    status: EntitlementStatusToJSON(value['status']),
    type: EntitlementTypeToJSON(value['type']),
    start: value['start'].toISOString(),
    end: value['end'].toISOString(),
    claimedAt:
      value['claimedAt'] == null ? undefined : value['claimedAt'].toISOString(),
    orbCreditBlockID: value['orbCreditBlockID'],
    salesforceSubID: value['salesforceSubID'],
    rollOverCreditBlockID: value['rollOverCreditBlockID'],
    rolloverPercentage: value['rolloverPercentage'],
    provisioningID: value['provisioningID'],
  };
}
